module.exports = __webpack_public_path__ + "static/media/180-french-polynesia.41aeee67.svg";